import apiUrl from '../../../constants';
import axios from 'axios';
import {
  Validator
} from 'vee-validate';

export default new class {
  async getTraceIP(input) {
      try {
        let result = await axios({
          method: 'POST',
        	'url': apiUrl.iptracker_url + 'UserTracker',
        	'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
  }

  Validator.extend('validate_gst', {
    getMessage: field => "The GST No field format is invalid",
    validate: value => {
      // var gstno = $("#GstNo").val();
      if (value.toLowerCase() == 'urp'  || value.match(/^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}Z[0-9a-zA-Z]{1}$/)) {
        if (value.toLowerCase() != '00xxxxx0000x1zz') {
          return true;
        }else{
          return false
        }
      }else{
        return false;
      }
    }
  });

  



// WEBPACK FOOTER //
// ./src/views/components/commonfunction/iptracker.js